// react
import React, { Component, PropTypes } from "react"
// material-ui
import { Card, CardHeader, CardActions, CardText } from "material-ui/Card"
import { Table, TableBody, TableHeader, TableRow, TableHeaderColumn, TableRowColumn } from "material-ui/Table"
// app
import Add from "./add.js"
import AddRemove from "components/common/buttons/AddRemove"
import SaveCancel from "components/common/buttons/SaveCancel"
// style
import "./person-languages.styl"

const initialState = {
    add: false,
    selectedRow: false,
    language: "",
    level: "",
    code: "",
}

class PersonLanguages extends Component {
    constructor(props) {
        super(props)
        this.state = initialState

        this.add = () => this.setState({ add: true })
        this.cancel = () => this.setState(initialState)

        this.save = this.save.bind(this)
        this.handleRowSelection = this.handleRowSelection.bind(this)
        this.remove = this.remove.bind(this)

        this.onLanguageChange = language => this.setState({ language })
        this.onLanguageLevelChange = level => this.setState({
            level: level.text,
            code: level.code
        })
    }

    handleRowSelection(rows) {
        const row = (typeof rows[0] === "number") ? (rows[0]) : false
        this.setState({ selectedRow: row })
    }

    save() {
        this.props.onSave(this.state)
        this.setState(initialState)
    }

    remove() {
        if (this.state.selectedRow === false) return
        const language = this.props.data.get(this.state.selectedRow)
        this.props.onRemove(language.get("id"))
        this.setState(initialState)
    }

    render() {
        const data = []
        let i = 0

        this.props.data.forEach(language => {
            data.push(
                <TableRow
                    key={ language.get("id") }
                    selected={ this.state.selectedRow === i++ }
                    style={{
                        color: (language.get("user_created") === "admin" ? "#09c": "")
                    }}
                >
                    <TableRowColumn>{ language.get("language") }</TableRowColumn>
                    <TableRowColumn>{ language.get("code") } <small>({ language.get("level") })</small></TableRowColumn>
                </TableRow>
            )
        })

        return (
            <Card className="card">
                <CardHeader
                    title="Languages"
                    style={{ paddingBottom: 0 }}
                />
                <CardText>
                    <Table
                        onRowSelection={ this.handleRowSelection }
                    >
                        {
                            data.length > 0 ?
                                <TableHeader displaySelectAll={ false }>
                                    <TableRow>
                                        <TableHeaderColumn>Language</TableHeaderColumn>
                                        <TableHeaderColumn>Level</TableHeaderColumn>
                                    </TableRow>
                                </TableHeader>
                            :
                            null
                        }
                        <TableBody showRowHover={ true }>
                            { data }
                        </TableBody>
                    </Table>
                    { this.state.add ?
                        <Add 
                            onLanguageChange={ this.onLanguageChange }
                            onLanguageLevelChange={ this.onLanguageLevelChange }
                        />
                        : null }
                </CardText>
                <CardActions>
                    { this.state.add ?
                        <SaveCancel
                            onSave={ this.save }
                            onCancel={ this.cancel }
                            disabled={ this.state.language === "" || this.state.languagelevel === "" }
                        />
                        :
                        <AddRemove
                            onAdd={ this.add }
                            onRemove={ this.remove }
                            disabled={ this.state.selectedRow === false }
                        />
                    }
                </CardActions>
            </Card>
        )
    }
}

PersonLanguages.propTypes = {
    data: PropTypes.object.isRequired, // immutable.List()
    onSave: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired
}

export default PersonLanguages


/** WEBPACK FOOTER **
 ** ./src/components/person/Languages/person-languages.js
 **/